import { defineMessages } from 'react-intl';

export default defineMessages({
  closeButtonLabel: {
    id: 'bitbucket.metadataPanel.closeButtonLabel',
    description: 'Icon label for close button inside panel',
    defaultMessage: 'Close panel',
  },
});
